import { Controller, useFormContext } from "react-hook-form";

import "./stepperInput.scss";
import { ReactComponent as StepperMinus } from "assets/images/icons/StepperMinus.svg";
import { ReactComponent as StepperPlus } from "assets/images/icons/StepperPlus.svg";

interface StepperInputProps {
  name: string;
  defaultValue?: number;
  required?: boolean;
  validations?: Record<string, any>;
  disabled?: boolean;
}

function StepperInput({ name, defaultValue = 0, required, validations, disabled }: StepperInputProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      rules={{ required, ...validations }}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => {
        const handleMinus = () => {
          if (value > 0) onChange(value - 1);
        };

        const handlePlus = () => {
          onChange(value + 1);
        };

        return (
          <div className="stepper-container">
            <button type="button" className="stepper-button minus" onClick={handleMinus} disabled={disabled}>
              <StepperMinus />
            </button>
            <input
              min={0}
              className="stepper-input"
              type="text"
              name={name}
              value={value}
              onChange={(val) => {
                if (isNaN(Number(val.target.value))) return;
                onChange(Number(val.target.value));
              }}
              inputMode="numeric"
              pattern="^[0-9]+$"
              style={{ margin: "0 5px", textAlign: "center" }}
              disabled={disabled}
            />
            <button className="stepper-button plus" type="button" onClick={handlePlus} disabled={disabled}>
              <StepperPlus />
            </button>
          </div>
        );
      }}
    />
  );
}

StepperInput.defaultProps = {
  defaultValue: 0,
  required: false,
  validations: undefined,
  disabled: false,
};

export default StepperInput;
